import React from 'react';
import { connect } from 'react-redux';

import {
  classifyCard,
  cardTypeImageMap,
} from '../../utils/SavedCardUtils';

const SavedCards = ({
  savedCards,
  handleSelectPaymentOption,
}) => {
  if (!savedCards) {
    return null;
  } else {
    const {
      name,
      type,
      submissionUris,
    } = savedCards;
    return (
      <div>
        <div className="text-light-grey push--ends">
          Saved Cards
        </div>
        {
          submissionUris.map( (card, index) => {
            const {
              firstSix,
              lastFour,
            } = card;
            return (
              <a
                key={index}
                className="btn btn-block push--bottom text--left"
                onClick={() => handleSelectPaymentOption({ name, type, selectedSavedCard: card })}>
                <span style={{ verticalAlign: 'middle' }}>
                  { `${firstSix.slice(0, 4)} **** **** ${lastFour}` }
                </span>
                <span className="float--right">
                  <img
                    src={cardTypeImageMap[classifyCard(firstSix)]}
                    style={{ height: '24px' }}
                  />
                </span>
              </a>
            );
          })
        }
      </div>
    );
  }
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(SavedCards);



// WEBPACK FOOTER //
// ./src/payments/views/finalize/SavedCards.js